// production URI
export const API_URL = "https://cbc.5techg.com/api/";

// dev URI
//export const API_URL = "http://localhost:5000";
